"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const company_document_map_entity_1 = require("./company-document-map.entity");
const contact_document_map_entity_1 = require("./contact-document-map.entity");
const task_document_map_entity_1 = require("./task-document-map.entity");
const note_document_map_entity_1 = require("./note-document-map.entity");
const meeting_document_map_entity_1 = require("./meeting-document-map.entity");
const look_up_entity_1 = require("./look-up.entity");
let FileUpload = class FileUpload {
};
exports.FileUpload = FileUpload;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], FileUpload.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "file_key", type: "text", nullable: false }),
    tslib_1.__metadata("design:type", String)
], FileUpload.prototype, "fileKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "upload_type", type: "varchar", length: 50 }),
    tslib_1.__metadata("design:type", String)
], FileUpload.prototype, "uploadType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], FileUpload.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], FileUpload.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FileUpload.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FileUpload.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_type", type: "varchar" }),
    tslib_1.__metadata("design:type", String)
], FileUpload.prototype, "companyType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "document_type_lid", type: "number" }),
    tslib_1.__metadata("design:type", Number)
], FileUpload.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "company_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], FileUpload.prototype, "companyId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamp", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], FileUpload.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToOne)(() => look_up_entity_1.LookUp),
    (0, typeorm_1.JoinColumn)({ name: "document_type_lid", referencedColumnName: "id" }),
    tslib_1.__metadata("design:type", Object)
], FileUpload.prototype, "documentType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => company_document_map_entity_1.CompanyDocMap, (companyDocMap) => companyDocMap.document),
    tslib_1.__metadata("design:type", Array)
], FileUpload.prototype, "companyDocMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => contact_document_map_entity_1.ContactDocMap, (contactDocMap) => contactDocMap.document),
    tslib_1.__metadata("design:type", Array)
], FileUpload.prototype, "contactDocMaps", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => task_document_map_entity_1.TaskDocumentMap, (taskDoc) => taskDoc.document),
    tslib_1.__metadata("design:type", Array)
], FileUpload.prototype, "taskDocs", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => note_document_map_entity_1.NoteDocumentMap, (noteDoc) => noteDoc.document),
    tslib_1.__metadata("design:type", Array)
], FileUpload.prototype, "noteDocs", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => meeting_document_map_entity_1.MeetingDocumentMap, (meetingDoc) => meetingDoc.document),
    tslib_1.__metadata("design:type", Array)
], FileUpload.prototype, "meetingDocs", void 0);
exports.FileUpload = FileUpload = tslib_1.__decorate([
    (0, typeorm_1.Entity)("file_uploads")
], FileUpload);
